import {Action, ActionReducerMap} from '@ngrx/store';
import * as actionsUi from './aufgaben-berechtigungen-checklisten.actions.ui';
import {APP_RESET_ACTION} from '@orga-app/appstart/actions';
import {GET_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN, GET_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ERFOLGREICH, GET_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_FEHLER, GetFunktionsbereichAufgabenBenutzerBerechtigungenErfolgreichAction, POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_ERFOLGREICH, POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN_ERFOLGREICH} from '../../../../client-ngrx/vorlagen';
import {ChecklisteAufgaben2} from '../../../../clients/vorlagen';
import {BENUTZER_BERECHTIGUNGEN_ENTFERNEN, BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN, PageLoadDataAction, SET_SELECTED_AUFGABEN, SetSelectedAufgabenAction} from './aufgaben-berechtigungen-checklisten.actions.ui';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    checklistenAufgaben: Array<ChecklisteAufgaben2>;
    checklistenAufgabenFehler: boolean;
    checklistenAufgabenLaden: boolean;

    selectedAufgaben: Array<string>;

    currentFunktionsbereichsId: string;
}

export const initialPageState: PageState = {
    checklistenAufgaben: [],
    checklistenAufgabenFehler: false,
    checklistenAufgabenLaden: false,

    selectedAufgaben: [],

    currentFunktionsbereichsId: null
};


export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        // PAGE STATE RESET
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        case actionsUi.PAGE_DATEN_LADEN: {
            const a = <PageLoadDataAction> action;

            return Object.assign({}, state, <PageState> {
                currentFunktionsbereichsId: a.payload
            });
        }

        case GET_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN: {
            return Object.assign({}, state, <PageState> {
                checklistenAufgabenLaden: true,
                checklistenAufgabenFehler: false
            });
        }

        case GET_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ERFOLGREICH: {
            const a = <GetFunktionsbereichAufgabenBenutzerBerechtigungenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                checklistenAufgabenLaden: false,
                checklistenAufgabenFehler: false,
                checklistenAufgaben: a.payload
            });
        }

        case GET_FUNKTIONSBEREICH_AUFGABEN_BENUTZER_BERECHTIGUNGEN_FEHLER: {
            return Object.assign({}, state, <PageState> {
                checklistenAufgabenLaden: false,
                checklistenAufgabenFehler: true
            });
        }

        case SET_SELECTED_AUFGABEN: {
            const a = <SetSelectedAufgabenAction> action;

            return Object.assign({}, state, <PageState> {
                selectedAufgaben: a.payload
            });
        }

        case POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState> {
                selectedAufgaben: []
            });
        }

        case POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState> {
                selectedAufgaben: []
            });
        }

        default: {
            return state;
        }
    }
}
